import AssignmentIcon from '@mui/icons-material/Assignment';
import EmailIcon from '@mui/icons-material/Email';
import MarkEmailReadIcon from '@mui/icons-material/MarkEmailRead';
import NoteAltIcon from '@mui/icons-material/NoteAlt';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import GroupsIcon from '@mui/icons-material/Groups';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ReceiptIcon from '@mui/icons-material/Receipt';
import BarChartIcon from '@mui/icons-material/BarChart';
import SettingsIcon from '@mui/icons-material/Settings';
import InventoryIcon from '@mui/icons-material/Inventory';
import SvgColor from '../components/svg-color';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

export const USA_STATES = [
  { name: 'Alabama', abbreviation: 'AL' },
  { name: 'Alaska', abbreviation: 'AK' },
  { name: 'Arizona', abbreviation: 'AZ' },
  { name: 'Arkansas', abbreviation: 'AR' },
  { name: 'California', abbreviation: 'CA' },
  { name: 'Colorado', abbreviation: 'CO' },
  { name: 'Connecticut', abbreviation: 'CT' },
  { name: 'Delaware', abbreviation: 'DE' },
  { name: 'Florida', abbreviation: 'FL' },
  { name: 'Georgia', abbreviation: 'GA' },
  { name: 'Hawaii', abbreviation: 'HI' },
  { name: 'Idaho', abbreviation: 'ID' },
  { name: 'Illinois', abbreviation: 'IL' },
  { name: 'Indiana', abbreviation: 'IN' },
  { name: 'Iowa', abbreviation: 'IA' },
  { name: 'Kansas', abbreviation: 'KS' },
  { name: 'Kentucky', abbreviation: 'KY' },
  { name: 'Louisiana', abbreviation: 'LA' },
  { name: 'Maine', abbreviation: 'ME' },
  { name: 'Maryland', abbreviation: 'MD' },
  { name: 'Massachusetts', abbreviation: 'MA' },
  { name: 'Michigan', abbreviation: 'MI' },
  { name: 'Minnesota', abbreviation: 'MN' },
  { name: 'Mississippi', abbreviation: 'MS' },
  { name: 'Missouri', abbreviation: 'MO' },
  { name: 'Montana', abbreviation: 'MT' },
  { name: 'Nebraska', abbreviation: 'NE' },
  { name: 'Nevada', abbreviation: 'NV' },
  { name: 'New Hampshire', abbreviation: 'NH' },
  { name: 'New Jersey', abbreviation: 'NJ' },
  { name: 'New Mexico', abbreviation: 'NM' },
  { name: 'New York', abbreviation: 'NY' },
  { name: 'North Carolina', abbreviation: 'NC' },
  { name: 'North Dakota', abbreviation: 'ND' },
  { name: 'Ohio', abbreviation: 'OH' },
  { name: 'Oklahoma', abbreviation: 'OK' },
  { name: 'Oregon', abbreviation: 'OR' },
  { name: 'Pennsylvania', abbreviation: 'PA' },
  { name: 'Rhode Island', abbreviation: 'RI' },
  { name: 'South Carolina', abbreviation: 'SC' },
  { name: 'South Dakota', abbreviation: 'SD' },
  { name: 'Tennessee', abbreviation: 'TN' },
  { name: 'Texas', abbreviation: 'TX' },
  { name: 'Utah', abbreviation: 'UT' },
  { name: 'Vermont', abbreviation: 'VT' },
  { name: 'Virginia', abbreviation: 'VA' },
  { name: 'Washington', abbreviation: 'WA' },
  { name: 'West Virginia', abbreviation: 'WV' },
  { name: 'Wisconsin', abbreviation: 'WI' },
  { name: 'Wyoming', abbreviation: 'WY' },
];

export const CLIENT_SIDEBAR_ITEMS = [
  {
    title: 'Support Tickets',
    path: '/support-tickets',
    icon: icon('ic_questions'),
  },
];

export const ASSOCIATE_SIDEBAR_ITEMS = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: icon('ic_analytics'),
  },

  {
    title: 'Claim Charges Upload',
    path: '/claim-charge-submissions-upload',
    icon: <NoteAltIcon />,
  },
];

export const ADMIN_SIDEBAR_ITEMS = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: icon('ic_analytics'),
  },
  {
    title: 'Claim Charges Upload',
    path: '/claim-charge-submissions-upload',
    icon: <NoteAltIcon />,
  },
  {
    title: 'agreements',
    path: '/contracts',
    icon: icon('ic_lock'),
  },
  // {
  //   title: 'VeriDoc',
  //   path: '/veridoc/new',
  //   icon: icon('ic_lock'),
  // },
  {
    title: 'Clients',
    path: 'clients',
    icon: icon('ic_user'),
  },
  // {
  //   title: 'Audit Trail',
  //   path: '/audit-trail',
  //   icon: icon('ic_vector'),
  // },
  {
    title: 'Support Tickets',
    path: '/support-tickets',
    icon: icon('ic_questions'),
  },
  {
    title: 'Tasks',
    path: '/background-tasks',
    icon: <AssignmentIcon />,
  },
  {
    title: 'Email Tracking',
    path: '/email-tracking',
    icon: <EmailIcon />,
  },
  {
    title: 'Email Sender',
    path: '/email-sender',
    icon: <MarkEmailReadIcon />,
  },
  {
    title: 'Teams',
    path: '/teams',
    icon: <GroupsIcon />,
  },
  // {
  //   title: 'Storage Manager',
  //   path: '/storage-manager',
  //   icon: <BackupIcon />,
  // },

  {
    title: 'HR',
    path: '/hr',
    icon: <PeopleAltIcon />,
    children: [
      {
        title: 'Employee Management',
        path: '/hr/employees',
        icon: <PeopleAltIcon />,
      },
      {
        title: 'Attendance Tracking',
        path: '/hr/attendance',
        icon: <AccessTimeIcon />,
      },
      {
        title: 'Leave Management',
        path: '/hr/leave',
        icon: <BeachAccessIcon />,
      },
      {
        title: 'Payroll Processing',
        path: '/hr/payroll',
        icon: <AttachMoneyIcon />,
      },
      {
        title: 'Expense Management',
        path: '/hr/expenses',
        icon: <ReceiptIcon />,
      },
      {
        title: 'Income Management',
        path: '/hr/income',
        icon: <AttachMoneyIcon />,
      },
      {
        title: 'Money Account Management',
        path: '/hr/accounts',
        icon: <AccountBalanceWalletIcon />,
      },
      {
        title: 'Inventory Management',
        path: '/hr/inventory',
        icon: <InventoryIcon />,
      },
      {
        title: 'Inventory Assignments',
        path: '/hr/inventory-assignments',
        icon: <AssignmentIcon />,
      },
      {
        title: 'Settings & Configuration',
        path: '/hr/settings',
        icon: <SettingsIcon />,
      },
      {
        title: 'Employee Dashboard',
        path: '/hr/employee-dashboard',
        icon: <DashboardIcon />,
      },
    ],
  },
  {
    title: 'Reports & Analytics',
    icon: <BarChartIcon />,
    children: [
      {
        title: 'Finance Dashboard',
        path: '/finance-dashboard',
        icon: <AttachMoneyIcon />,
      },
    ],
  },
];

export const HR_SIDEBAR_ITEMS = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: icon('ic_analytics'),
  },
  {
    title: 'HR',
    path: '/hr',
    icon: <PeopleAltIcon />,
    children: [
      {
        title: 'Employee Management',
        path: '/hr/employees',
        icon: <PeopleAltIcon />,
      },
      {
        title: 'Attendance Tracking',
        path: '/hr/attendance',
        icon: <AccessTimeIcon />,
      },
      {
        title: 'Leave Management',
        path: '/hr/leave',
        icon: <BeachAccessIcon />,
      },
      {
        title: 'Payroll Processing',
        path: '/hr/payroll',
        icon: <AttachMoneyIcon />,
      },
      {
        title: 'Expense Management',
        path: '/hr/expenses',
        icon: <ReceiptIcon />,
      },
      {
        title: 'Income Management',
        path: '/hr/income',
        icon: <AttachMoneyIcon />,
      },
      {
        title: 'Money Account Management',
        path: '/hr/accounts',
        icon: <AccountBalanceWalletIcon />,
      },
      {
        title: 'Inventory Management',
        path: '/hr/inventory',
        icon: <InventoryIcon />,
      },
      {
        title: 'Inventory Assignments',
        path: '/hr/inventory-assignments',
        icon: <AssignmentIcon />,
      },
      {
        title: 'Settings & Configuration',
        path: '/hr/settings',
        icon: <SettingsIcon />,
      },
      {
        title: 'Employee Dashboard',
        path: '/hr/employee-dashboard',
        icon: <DashboardIcon />,
      },
    ],
  },
];

export const OTHER_SIDEBAR_ITEMS = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    icon: icon('ic_analytics'),
  },
];

// App-based Navigation Items
export const APP_NAV_ITEMS = {
  admin: [
    {
      title: 'Dashboard',
      path: '/dashboard',
      icon: <DashboardIcon />,
    },
    {
      title: 'Agreements',
      path: '/contracts',
      icon: icon('ic_lock'),
    },
    {
      title: 'Claim Charges Upload',
      path: '/claim-charge-submissions-upload',
      icon: <NoteAltIcon />,
    },
    {
      title: 'Support Tickets',
      path: '/support-tickets',
      icon: icon('ic_questions'),
    },
    {
      title: 'Email Tracking',
      path: '/email-tracking',
      icon: <EmailIcon />,
    },
    {
      title: 'Email Sender',
      path: '/email-sender',
      icon: <MarkEmailReadIcon />,
    },
    {
      title: 'Clients',
      path: '/clients',
      icon: icon('ic_user'),
    },
  ],
  hr: [
    {
      title: 'Employee Dashboard',
      path: '/hr/employee-dashboard',
      icon: <DashboardIcon />,
    },
    {
      title: 'Employee Management',
      path: '/hr/employees',
      icon: <PeopleAltIcon />,
    },
    {
      title: 'Attendance Tracking',
      path: '/hr/attendance',
      icon: <AccessTimeIcon />,
    },
    {
      title: 'Leave Management',
      path: '/hr/leave',
      icon: <BeachAccessIcon />,
    },
    {
      title: 'Payroll Processing',
      path: '/hr/payroll',
      icon: <AttachMoneyIcon />,
    },
    {
      title: 'Expense Management',
      path: '/hr/expenses',
      icon: <ReceiptIcon />,
    },
    {
      title: 'Income Management',
      path: '/hr/income',
      icon: <AttachMoneyIcon />,
    },
    {
      title: 'Money Account Management',
      path: '/hr/accounts',
      icon: <AccountBalanceWalletIcon />,
    },
    {
      title: 'Inventory Management',
      path: '/hr/inventory',
      icon: <InventoryIcon />,
    },
    {
      title: 'Inventory Assignments',
      path: '/hr/inventory-assignments',
      icon: <AssignmentIcon />,
    },
    {
      title: 'Settings & Configuration',
      path: '/hr/settings',
      icon: <SettingsIcon />,
    },
    {
      title: 'Teams Page',
      path: '/teams',
      icon: <GroupsIcon />,
    },
  ],
  finance: [
    {
      title: 'Finance Dashboard',
      path: '/finance-dashboard',
      icon: <AttachMoneyIcon />,
    },
  ],
  task: [
    {
      title: 'Tasks',
      path: '/background-tasks',
      icon: <AssignmentIcon />,
    },
  ],
};

export const getPathToAppMapping = () => {
  const mapping = {};
  Object.entries(APP_NAV_ITEMS).forEach(([appKey, items]) => {
    items.forEach((item) => {
      mapping[item.path] = appKey;
      if (item.children) {
        item.children.forEach((child) => {
          mapping[child.path] = appKey;
        });
      }
    });
  });
  return mapping;
};
